module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Ce-Db-Ef-Fb-Gd.d37b52ea.png";